import { DefaultTag } from '@lib/common';
import { colors } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
export var AssignmentTypeTag = function AssignmentTypeTag(_ref) {
  var typeId = _ref.typeId,
      typeName = _ref.typeName;

  var getTagColor = function getTagColor(typeId) {
    // TODO: add color for each assignment type
    return colors.dark.textIntHighlighted;
  };

  return /*#__PURE__*/_jsx(DefaultTag, {
    color: getTagColor(typeId),
    children: typeName
  });
};